import * as ActionTypes from '../actions/actionTypes'

export default function reduce(state = {}, action) {
    switch(action.type) {
        case ActionTypes.SET_NORMALIZED_LANGUAGE:

        return Object.assign({}, state, {
            [action.payload.stateLocation]: action.payload.language
        })
    
        break;
    
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/normalize-language/src/reducers/index.js